import { render } from "./MarketingPolicy.vue?vue&type=template&id=49d977e0&scoped=true"
import script from "./MarketingPolicy.vue?vue&type=script&lang=js"
export * from "./MarketingPolicy.vue?vue&type=script&lang=js"

import "./MarketingPolicy.vue?vue&type=style&index=0&id=49d977e0&scoped=true&lang=css"

import exportComponent from "D:\\케이터링\\html(JW 가상화서버)\\justinfood\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49d977e0"]])

export default __exports__